import { render } from "./SecondaryInsights.vue?vue&type=template&id=56bc1c04&ts=true"
import script from "./SecondaryInsights.vue?vue&type=script&lang=ts"
export * from "./SecondaryInsights.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__